/**
 * Identité PUBLIQUE du projet Supabase SwiftDeliver — le SEUL endroit de cette console où elle est écrite.
 *
 * Paramétrable AU BUILD, sans toucher au code (passage à Supabase auto-hébergé) :
 *   VITE_SUPABASE_URL        ex. `https://api-deliver.yiriwa-group.com`
 *   VITE_SUPABASE_ANON_KEY   la clé publique du projet (clé « anon » JWT ou `sb_publishable_…`)
 * Absentes ou vides : la production actuelle, ci-dessous. Le build Vercel (`scripts/build-vercel.mjs`) les
 * alimente depuis `SWIFTDELIVER_SUPABASE_URL` / `SWIFTDELIVER_SUPABASE_ANON_KEY` — voir `web-commun/config-supabase.ts`
 * et `infra/vps/migration/RUNBOOK.md` § 7.
 *
 * Module SANS client Supabase : une page qui n'a besoin que de l'adresse (réinitialisation du mot de passe,
 * réglages d'authentification) l'importe sans charger le client de la console.
 *
 * La clé est publique par conception : elle identifie le projet, elle n'autorise rien. Ce qu'un porteur peut
 * lire ou écrire est décidé par la RLS. Jamais de clé `service_role` ni `sb_secret_`, ni ici ni en variable
 * de build : elle se retrouverait dans le bundle JavaScript, donc entre toutes les mains.
 */
import { choisirConfigSupabase } from '../../../../../web-commun/config-supabase'

/** La production actuelle (projet cloud `qohvwpyuzajajlvphwrv`). */
export const PROJET_PAR_DEFAUT = {
  url: 'https://qohvwpyuzajajlvphwrv.supabase.co',
  cle: 'sb_publishable_FPpzM8C5ACk0LDCswiNYMQ_K2rpym0z',
} as const

const projet = choisirConfigSupabase(
  {
    url: import.meta.env.VITE_SUPABASE_URL as string | undefined,
    cle: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
    ancienneCle: import.meta.env.VITE_SUPABASE_KEY as string | undefined,
  },
  PROJET_PAR_DEFAUT,
)

export const URL_SUPABASE: string = projet.url
export const CLE_PUBLISHABLE: string = projet.cle
